import { render, staticRenderFns } from "./Toplist.vue?vue&type=template&id=456d35dc&scoped=true&"
import script from "./Toplist.vue?vue&type=script&lang=ts&"
export * from "./Toplist.vue?vue&type=script&lang=ts&"
import style0 from "./Toplist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Toplist.vue?vue&type=style&index=1&id=456d35dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d35dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Romppu/source/repos/poker-serverless/pokerapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDialog,VList,VListTile,VListTileContent,VProgressLinear,VTab,VTabItem,VTabs})
